import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Role } from '../models/role';
import { UserService } from '../services/user.service';

@Component({
  selector: 'rl-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthenticationComponent implements OnInit {

  page: string;
  isRegisterEnabled: boolean;

  constructor(public bsModalRef: BsModalRef,
              private userService: UserService,
              private readonly router: Router,
              public readonly toastr: ToastrService) {
  }

  ngOnInit() {
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  goToRegister() {
    this.page = 'Register to demo';
  }

  goToLogin() {
    this.page = 'Login';
  }

  // async completeNewPassword(user): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     Auth.completeNewPassword(user, this.form.get('newPassword').value)
  //       .then((resp) => {
  //         this.event = LoginEvent.LOGIN;
  //         resolve(resp);
  //       })
  //       .catch(err => {
  //         console.log(err);
  //         reject(err);
  //       });
  //   });
  // }

  successLogin() {
    this.bsModalRef.hide();
    const user = this.userService.getUser();
    if (user.role === Role.RL_ADMIN) {
      this.router.navigateByUrl('admin/currency-management');
    } else {
      this.router.navigateByUrl('home');
    }
    this.bsModalRef.hide();
  }

  failedLogin(event) {
    this.toastr.error('Invalid username or password');
  }
}
